import { Component, Input, Output, ElementRef, EventEmitter } from '@angular/core';
import { TranslateService, TranslatePipe, LangChangeEvent } from '@ngx-translate/core';
import { GlobalVariables } from '../../../../../common/global-variables';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'time-picker',
  providers: [
    TranslateService
  ],
  styles: [require('./time-picker.scss')],
  template: require('./time-picker.html'),
  host: {
    '(document:click)': 'onClick($event)',
  }
})

export class TimePicker {
  @Input('time') time;
  @Input('isVisible') isVisible: boolean;
  @Output('onTimeChange') timeChanged = new EventEmitter();

  private _selectedTimeHours = "00";
  get selectedTimeHours() {
    return this._selectedTimeHours;
  }
  set selectedTimeHours(val) {
    this._selectedTimeHours = this.validateTimePicker(val, 23);
    if(this.editMode) this.emitTimeChange();
  }

  private _selectedTimeMinutes = "00";
  get selectedTimeMinutes() {
    return this._selectedTimeMinutes;
  }
  set selectedTimeMinutes(val) {
    this._selectedTimeMinutes = this.validateTimePicker(val, 59);
    if(this.editMode) this.emitTimeChange();
  }

  get selectedTime() {
    return this.selectedTimeHours + ":" + this.selectedTimeMinutes;
  }

  private editMode:boolean = false;

  constructor(private translate: TranslateService, private elmRef: ElementRef) {
    translate.use(GlobalVariables.LOCALE);
  }

  onClick(event) {
    //show edit mode if clicked on the component, and close edit mode if clicked outside
    if (!this.elmRef.nativeElement.contains(event.target))
      this.editMode = false;
    else
      this.editMode = true;
  }

  //Life Cycle Hooks
  ngOnInit() {
  }

  ngOnChanges(changes) {
    if(changes.time) {
      if(changes.time.hasOwnProperty('currentValue') && changes.time.currentValue
        && this.validateTime(changes.time.currentValue) ) {
          let arr = changes.time.currentValue.split(":")
          this.selectedTimeHours = arr[0];
          this.selectedTimeMinutes = arr[1];
      }
      else {
        this.reset();
      }
    }

    if(changes.isVisible) {
      if(changes.isVisible.hasOwnProperty('currentValue') && changes.isVisible.currentValue ) {
      }
      else {
        this.reset();
      }
    }
  }

  reset() {
    this.selectedTimeHours = "00";
    this.selectedTimeMinutes = "00";
  }

  //Reg Exp to verify the valid time range: from 00:00 to 23:59
  isValidHourMin(value) {
    let isValid:boolean = /^([0-1]?[0-9]|2[0-4]):([0-5][0-9])(:[0-5][0-9])?$/.test(value);
    return isValid;
  }

  //Valid format from JSON: from 00:00:00 to 23:59:00
  validateTime(value) {
    let arr = value.split(":");
    if(arr && arr.length === 3) {
      return true && this.isValidHourMin(arr[0] + ":" + arr[1]);
    }
    else {
      return false;
    }
  }

  validateTimePicker(value, limit) {
    var returnStringToNumber = Number(value);
    //Limit the max values
    if(returnStringToNumber > limit)
      returnStringToNumber = limit;

    //Make sure it's not a float or negative numbers. If yes, set it to zero
    if(returnStringToNumber % 1 !== 0 || returnStringToNumber < 0)
      returnStringToNumber = 0;

    return ("0" + returnStringToNumber).slice(-2);
  }

  emitTimeChange(): void {
    if (this.timeChanged) {
      this.timeChanged.emit({
        value: this.selectedTimeHours + ":" + this.selectedTimeMinutes + ":00"
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dataprotection/dataprotection-common/time-picker/time-picker.component.ts